import { get, post } from './request'

interface General {
    supplier: string;
    propertyId: string;
    property: {
        environmentalimpact: object
    };
}

type Cert = General
type EnvProg = General
type EnerGeneral = General
type EnerEnergyusage = General
type EnerUsageProgram = General
type WaterUsage = General

export const getEnvImpacts = (supplier: string, propertyid: string) => get(`/property/environmentalimpact?supplier=${supplier}&propertyid=${propertyid}`)

/*
    POST REQUEST: We will use this same request for both adding new general info and updating since there is only a 1-1 relationship.
    For Update we send generalid and generallangid.
    For add we don’t send generalid and generallangid
*/
export const addOrUpdateGeneral = (general: General) => post('/property/env/general/general', general)

/*
    POST REQUEST: We send a POST request for all requests. On the API side we delete all records and re add them on every request.
    if id and langid are not sent then we need to create a new record in the enviroimpact table and attach these certs to that record.
*/
export const addOrUpdateCert = (cert: Cert) => post('/property/env/general/cert', cert)

/*
    POST REQUEST: We send a POST request for all requests. On the API side we delete all records and re add them on every request.
    if id and langid are not sent then we need to create a new record in the enviroimpact table and attach these env programs to that record.
*/
export const addOrUpdateEnvProg = (envProg: EnvProg) => post('/property/env/general/envprog', envProg)

/*
    POST REQUEST: We will use this same request for both adding new general info and updating since there is only a 1-1 relationship.
    For Update we send generalid and generallangid.
    For add we don’t send generalid and generallangid
*/
export const addOrUpdateEnergyusageGeneral = (energyusageGeneral: EnerGeneral) => post('/property/env/energyusage/general', energyusageGeneral)

/*
    POST REQUEST: We send a POST request for all requests. On the API side we delete all records and re add them on every request.
    if id and langid are not sent then we need to create a new record in the enviroimpact table and attach these energy usages to that record.
*/
export const addOrUpdateEnergyusageEnergyusage = (energyusageEnergyusage: EnerEnergyusage) => post('/property/env/energyusage/energyusage', energyusageEnergyusage)

/*
    POST REQUEST: We send a POST request for all requests. On the API side we delete all records and re add them on every request.
    if id and langid are not sent then we need to create a new record in the enviroimpact table and attach these usage programs to that record.
*/
export const addOrUpdateEnergyusageProgram = (energyusageProgram: EnerUsageProgram) => post('/property/env/energyusage/usageprogram', energyusageProgram)

export const updateEnrivonmentalImpacts = (enrivonmentalImpacts: General) => post('/property/env/general', enrivonmentalImpacts)

